export default "__VITE_ASSET__3pQm67FV__"